import { useEffect } from 'react';

export default function ScrollToTopOnMount(): JSX.Element {
  useEffect(() => {
    if (window) {
      window.scrollTo(0, 0);
    }
  }, [])

  return null;
}
